export const selectGameBalance = (state) => state.game.balance

export const selectGameUserStatus = (state) => state.game.userStatus
